import { createElement } from 'react';
import TitleBar1 from './components/title-bar1';
import TitleBar2 from './components/title-bar2';
import TitleBar3 from './components/title-bar3';
import TitleBar4 from './components/title-bar4';
import TitleBar5 from './components/title-bar5';
import TitleBar6 from './components/title-bar6';
import TitleBar7 from './components/title-bar7';
import TitleBar8 from './components/title-bar8';
import TitleBar9 from './components/title-bar9';
import TitleBar11 from './components/title-bar11';
import TitleBar12 from './components/title-bar12';
const DataVTitleBar = ({ type = '1', ...rest }) => {
    const titleBarMaps = {
        '1': TitleBar1,
        '2': TitleBar2,
        '3': TitleBar3,
        '4': TitleBar4,
        '5': TitleBar5,
        '6': TitleBar6,
        '7': TitleBar7,
        '8': TitleBar8,
        '9': TitleBar9,
        '10': (props) => createElement(TitleBar6, { ...props, simple: true }),
        '11': TitleBar11,
        '12': TitleBar12,
    };
    const Comp = titleBarMaps[type];
    if (!Comp) {
        return null;
    }
    return createElement(Comp, { ...rest });
};
export default DataVTitleBar;
